import React from 'react';

export default class Page2 extends React.Component {

    render() {

        return <div id="region-main-pad">
            <div id="region-main"><span id="user-notifications"/>
                <div className="region-content">
                    <div role="main"><span id="maincontent"/>
                        <section>
                            <div className="">
                                <div className="ilead-rgt task">
                                    <div className="innerpadding">
                                        <div className="ilead-contentarea">
                                            <div className="border_subtitle">This tool can help</div>
                                            <p>
                                                Research has shown that resilience to overcome setbacks is not
                                                an inborn personality trait, it is
                                                something that can be learned.<a className="superscripttext "
                                                                                 href="further_info.php?course=300"><sup>2</sup></a> This
                                                tool is all about<span className="brown brownbold"> how to cope with setbacks</span> and
                                                helps you to
                                                understand what causes setbacks and develop the skills you need
                                                to overcome these obstacles.
                                            </p>

                                            <div className="circle_title"><img
                                                src={require('@images/Browndot.png')}
                                                alt=""/>THE SPORT MODEL
                                            </div>
                                            <p>We hope we’ve caught you at a good time. If you’re reading this
                                                thinking about some prolonged
                                                disappointment, or how you might nurse a colleague through one,
                                                you’ll agree with us that
                                                everyone experiences them and, of course, we can all think of
                                                successful people who’ve had their
                                                fair share of them. If, on the other hand, you’re still occupied
                                                by a more recent experience, you
                                                may feel you’d prefer to sit there a bit longer, staring at the
                                                wall.</p>
                                            <p>So, we’ll say this quietly: It’s a fact that we learn more when
                                                things don’t go according to plan than
                                                when it’s a breeze. The trick is how you deal with it – and
                                                that’s what marks out those infuriatingly
                                                successful people from the rest. Don’t assume you’re a failure,
                                                and don’t allow negativity or
                                                anxiety to spiral until it engulfs you. Take the time to work
                                                out what went wrong and why – and
                                                what insights this gives you for next time. This may sound
                                                impossible right now, but how you react
                                                is a choice, and like anything else, training yourself to think
                                                in ways that benefit you gets easier
                                                with practice.</p>
                                            <p>And, we have a strategy of our own for you to follow whenever you
                                                experience a setback at work,
                                                in your relationships or anything else that affects your general
                                                wellbeing. First, whether you want
                                                to analyse what went wrong with a previous plan or are about to
                                                create a new one, separate the
                                                planning process into 5 essential stages, best remembered as the
                                                acronym <span className="brown brownbold">SPORT</span>:<a
                                                    className="superscripttext "
                                                    href="further_info.php?course=300"><sup>2</sup></a></p>

                                            <div className="verticalword "><span
                                                className="greennumberroundbg CircleAbbr  ">S</span></div>
                                            <span className=" circlediscp verticalContentPadding">
    <p><span className="subtiltereg ">pecific – </span> so that everyone involved knows what is expected.</p></span>
                                            <div className="verticalword "><span
                                                className="greennumberroundbg CircleAbbr  ">P</span></div>
                                            <span className=" circlediscp verticalContentPadding">
    <p><span className="subtiltereg ">ositive – </span> in outlining what success looks like and how this will be achieved.</p></span>
                                            <div className="verticalword "><span
                                                className="greennumberroundbg CircleAbbr  ">O</span></div>
                                            <span className=" circlediscp verticalContentPadding">
    <p><span className="subtiltereg ">bservable – </span> with clear measurable stages to show how the final goal was achieved.</p></span>
                                            <div className="verticalword "><span
                                                className="greennumberroundbg CircleAbbr  ">R</span></div>
                                            <span className=" circlediscp verticalContentPadding">
    <p><span
        className="subtiltereg ">ealistic – </span> to ensure that there is a practical focus to the plan.</p></span>
                                            <div className="verticalword "><span
                                                className="greennumberroundbg CircleAbbr  ">T</span></div>
                                            <span className=" circlediscp verticalContentPadding">
    <p><span className="subtiltereg ">imed – </span> so that deadlines and timeframes are clearly established and followed.</p></span>

                                            <br/>
                                            <p>Making sure a plan incorporates SPORT will give it a better
                                                chance of success, because even if
                                                a setback occurs you’ll be able to identify the problem more
                                                easily, work out how to put it right
                                                and continue working towards your goal, rather than
                                                abandoning it as a failure.</p>
                                            <p>There’s a model of a SPORT plan, on the next page.</p>
                                            <p>In the model, the line of arrows at the top shows the 5
                                                stages of the plan (it’s backwards, but the
                                                acronym’s easier to remember!). We’ve indicated that a
                                                setback occurs, just as everything looks
                                                as if it’s all working out nicely!</p>
                                            <p>The backward-pointing arrows below the SPORT indicate what
                                                needs to be done to overcome
                                                the setback and realign with the original goal – or an
                                                amended goal if necessary. What’s needed
                                                will depend on the stage at which the setback occurs, but as
                                                a general rule, it’s a good idea
                                                to start with review and identify and then move through
                                                SPORT to work out where the setback
                                                has occurred.</p>
                                            <p>This is a method which allows review of an objective and the
                                                process used to achieve it. More
                                                importantly, it demonstrates that setbacks don’t
                                                automatically signify failure, but our attitude
                                                to them can! For more detail on how to review and identify
                                                and approach the other steps, there is
                                                help overleaf.</p>


                                            <div className="left-btn">
                                                <div
                                                    onClick={this.props.handleChangePage('Page1')}
                                                    className="button-next-previous-done task">&lt;&lt; Previous
                                                </div>
                                            </div>
                                            <div className="right-btn">
                                                <div
                                                    onClick={this.props.handleChangePage('Page3')}
                                                    className="button-next-previous-done task">Next &gt;&gt;</div>
                                            </div>

                                        </div>

                                    </div>


                                </div>
                            </div>

                        </section>


                    </div>
                </div>
            </div>
        </div>;
    }
}